import { dmApi } from "../dmApi";
import { handleQueryErrorAndSuccess, getAuthorizationHeader } from "../../helpers/RtkQueryUtils";
const surveyApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    createSurvey: build.mutation({
      query: (survey) => ({
        url: "/admin/create-surveys",
        method: "POST",
        body: survey,
        headers: getAuthorizationHeader()
      }),
      invalidatesTags: ['Survey'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Survey created');
      },
    }),
    getAllSurveys: build.query({
      query: ({ page = 1, limit = 10, search = "",id }) => ({
        url: `/admin/get-all-surveys?page=${page}&limit=${limit}&searchTerm=${search}&survey_category_id=${id}`,
        method: "GET",
        headers: getAuthorizationHeader()
      }),
      providesTags: ['Survey']
    }),
    getSurveyById: build.query({
      query: (surveyId) => ({
        url: `/admin/get-survey-by-id?surveyId=${surveyId}`,
        method: "GET",
        headers: getAuthorizationHeader()
      }),
        providesTags: ['Survey']
    }),
    getAssignedOddoSurveyById: build.query({
      query: ({ leadId, page = 1, limit = 10, search = "" }) => ({
        url: `/admin/get-assigned-oddo-leads-survey?leadId=${leadId}&page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
        headers: getAuthorizationHeader()
      }),
      providesTags: ['OddoSurvey']
    }),
    updateSurvey: build.mutation({
      query: ({ surveyId, body }) => ({
        url: `/admin/update-survey?surveyId=${surveyId}`,
        method: "PUT",
        body: body,
        headers: {
          ...getAuthorizationHeader()
        }
      }),
      invalidatesTags: ['Survey'],
    }),
    uploadImageMetadata: build.mutation({
      query: ({  body }) => ({
        url: `/admin/upload-image-metadata-admin`,
        method: "PUT",
        body: body,
        headers: {
          ...getAuthorizationHeader()
        }
      }),
      invalidatesTags: ['Survey'],
    }),
    shuffleSurveyQuestions: build.mutation({
      query: ({  body }) => ({
        url: `/admin/shuffle-survey-questions`,
        method: "PUT",
        body: body,
        headers: {
          ...getAuthorizationHeader()
        }
      }),
      invalidatesTags: ['Survey'],
    }),
    deleteSurvey: build.mutation({
      query: ({ surveyId }) => ({
        url: `/admin/delete-survey`,
        method: "DELETE",
        body: { surveyId },
        headers: {
          ...getAuthorizationHeader(),
        },
      }),
      invalidatesTags: ['Survey'],
    }),
    unassignSurvey: build.mutation({
      query: ({ surveyId, userId,leadId }) => ({
        url: `/admin/unassign-survey`,
        method: "PUT",
        body: { surveyId, userId,leadId },
        headers: {
          ...getAuthorizationHeader()
        }
      }),
      invalidatesTags: ['AssignedSurveys'],
    }),
    getUnassignedSurveys: build.query({
      query: ({ userId, page = 1, limit = 10, search = "",leadId }) => ({
        url: `/admin/get-unassigned-surveys?userId=${userId}&leadId=${leadId}&page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['SurveyUnsassigned']
    }),
    getUnassignedOddSurveys: build.query({
      query: ({ leadId, page = 1, limit = 10, search = "" }) => ({
        url: `admin/get-unassigned-oddo-leads-survey?leadId=${leadId}&page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['oddoUnassignSurvey']
    }),
    assignSurvey: build.mutation({
      query: (body) => ({
        url: "/admin/assign-survey",
        method: "POST",
        body,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['SurveyUnsassigned', 'AssignedSurveys'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Survey assigned successfully');
      },
    }),
    assignSurveyToOddoLead: build.mutation({
      query: ({ leadId, surveyId }) => ({
        url: `/admin/assign-survey-to-oddo-leads`,
        method: 'POST',
        params: { leadId, surveyId },
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['oddoUnassignSurvey', 'OddoSurvey'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Survey assigned successfully');
      },
    }),
    getUserSurveyResponse: build.query({
      query: ({ userId, surveyId, leadId }) => ({
        url: `/admin/get-user-survey-response?userId=${userId}&surveyId=${surveyId}&leadId=${leadId}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
    }),
    deleteSurveyPermanent: build.mutation({
      query: ({ surveyId }) => ({
        url: `/admin/delete-survey-force`,
        method: "DELETE",
        headers: getAuthorizationHeader(),
        body: {surveyId}
      }),
       invalidatesTags: ['Survey'],
    }),
  }),
});

export const {
  useCreateSurveyMutation,
  useGetAllSurveysQuery,
  useGetSurveyByIdQuery,
  useGetAssignedOddoSurveyByIdQuery,
  useGetUnassignedSurveysQuery,
  useGetUnassignedOddSurveysQuery,
  useAssignSurveyMutation,
  useAssignSurveyToOddoLeadMutation,
  useUpdateSurveyMutation,
  useUnassignSurveyMutation,
  useDeleteSurveyMutation,
  useGetUserSurveyResponseQuery,
  useDeleteSurveyPermanentMutation,
  useShuffleSurveyQuestionsMutation,
  useUploadImageMetadataMutation
} = surveyApi;
